import { Environment } from '@abp/ng.core';

const baseUrl = 'https://maavaishnodevi.ca';

const oAuthConfig = {
  issuer: 'https://api.maavaishnodevi.ca/',
  redirectUri: baseUrl,
  clientId: 'Mandir_Public_App',
  responseType: 'token',
  scope: 'offline_access Mandir',
  requireHttps: true,
};

export const environment = {
  production: true,
  websiteMode:'UAT',
  primaryColor:'#007a15',
  application: {
    baseUrl,
    name: 'Mandir',
  },
  oAuthConfig,
  apis: {
    default: {
      url: 'https://api.maavaishnodevi.ca',
      rootNamespace: 'Mandir',
    },
    AbpAccountPublic: {
      url: oAuthConfig.issuer,
      rootNamespace: 'AbpAccountPublic',
    },
  },
  stripeKey: 'pk_test_51JtaS3FrOhkM1MXVYnRTmNrZEpQiK8DLsx8OqX0fnhmC1Bl2mSGbJVtvnC6aGONss7kf1uwS7VNQTWDithvP74FD00KYklKKaN',
  kioskMode: 'TEST'
  // remoteEnv: {
  //   url: '/getEnvConfig',
  //   mergeStrategy: 'deepmerge'
  // }
} as Environment;
